import { fnv1a32RecordHash } from "../science/provenance.mjs";

export function createApprovalLogEntry({ target, action, index, now = new Date() }) {
  const at = now.toISOString();
  const entryCore = {
    target,
    action,
    at,
  };

  return {
    id: `${now.getTime()}-${index}`,
    ...entryCore,
    entryHash: fnv1a32RecordHash(entryCore),
  };
}

export function appendApprovalLogEntry(currentEntries, target, action, now = new Date()) {
  return [createApprovalLogEntry({ target, action, index: currentEntries.length, now }), ...currentEntries];
}
